import MenuItem, { MenuItemProps } from "@mui/material/MenuItem";
import React from "react";
import styled from "styled-components";

// Extend MenuItemProps to include disableCloseOnClick
export interface ArgosMenuItemProps extends MenuItemProps {
  disableCloseOnClick?: boolean;
}

const StyledMenuItem = styled(MenuItem)({});

const ArgosMenuItem: React.FC<ArgosMenuItemProps> = (props) => {
  return <StyledMenuItem {...props} />;
};

export default ArgosMenuItem;